var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3084 8.57009C15.3084 12.8266 11.8819 16.2769 7.65365 16.2769C3.4265 16.2769 0 12.8266 0 8.57009C0 4.31353 3.4265 0.863281 7.65478 0.863281C11.8819 0.863281 15.3084 4.31353 15.3084 8.57009ZM23.7064 8.56989C23.7064 12.5765 21.9931 15.8244 19.8796 15.8244C17.766 15.8244 16.0527 12.5765 16.0527 8.56989C16.0527 4.56326 17.766 1.31543 19.8796 1.31543C21.992 1.31543 23.7064 4.56326 23.7064 8.56989ZM25.7949 15.0702C26.5379 15.0702 27.1407 12.1594 27.1407 8.57001C27.1407 4.98066 26.5379 2.06982 25.7949 2.06982C25.052 2.06982 24.4492 4.97953 24.4492 8.57001C24.4492 12.1605 25.052 15.0702 25.7949 15.0702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLogo);
export default __webpack_public_path__ + "static/media/medium-logo.6fb288ba3343a237dc9dc793f44a15ac.svg";
export { ForwardRef as ReactComponent };